import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { ViewSchedulingGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/ViewScedulingSlice/CreateNewSchedulingSlice";
import { HeaderIllegal } from "../../../../IllegalConstructionDashboard/HeaderIllegal";
import EnchrochmentSidebar from "../../../EnchrochmentSidebar/EnchrochmentSidebar";
import { Loading } from "../../../../../../../../Helper/Loading";
import { ZoneNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { WardNameDDL } from "../../../../../../../../Components/IllegalDDL/WardNameDDL";
import { Pegination } from "../../../../../../../../Components/Pegination/Pegination";
import { WardGridPopup } from "../TodaySchedulingGrid/WardGridPopup";
import { AreaGridPopup } from "../TodaySchedulingGrid/AreaGridPopup";
import SizedItemDetailsPopUp from "../ClosedComplaintEnchrochmentGrid/Modal/SizedItemDetailsPopUp";
import PathakNamePopUp from "../ClosedComplaintEnchrochmentGrid/Modal/PathakNamePopUp";
import ViewURL from "../Modal/ViewURL";

export const SchedulingGrids = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()

    // let YearValue = searchParams.get("YearValue")
    // let MonthValue = searchParams.get("MonthValue")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");
    let Flag = searchParams.get("Flag");
    const ScreenNameTotal = searchParams.get('ScreenNameTotal')
    let ZoneID = searchParams.get("ZoneID")
    let ZoneName = searchParams.get("ZoneName")

    const [IsPost, setIsPost] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)
    // const [FromDate, setFromDate] = useState(ScreenNameTotal == 'Upcoming Scheduling' ? moment().format('YYYY-MM-DD') : '')

    const [FromDate, setFromDate] = useState('')
    const [ToDate, setToDate] = useState('')
    const todayDate = moment().format('YYYY-MM-DD');

    const [GridData, setGridData] = useState([])
    const [ViewSchedulingData, setViewSchedulingData] = useState([])


    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    const [PathakDetails, setPathakDetails] = useState(false)

    const handlePathakDetails = (data) => {
        setPathakDetails(!PathakDetails)
        setGridData(data)
    }

    const [WardPopup, setWardPopup] = useState(false)

    const handleWardPopup = (data) => {
        setGridData(data)
        setWardPopup(!WardPopup)
    }

    const [AreaPopup, setAreaPopup] = useState(false)

    const handleAreaPopup = (data) => {
        setGridData(data)
        setAreaPopup(!AreaPopup)
    }
    // ----------------Track PopUp ----------------

    const [TrackPopUpShow, setTrackPopUpShow] = useState(false)

    const handleTrack = () => {
        setTrackPopUpShow(!TrackPopUpShow)
    }

    // handleSizedItemDetails 
    const [SizedItemDetail, setSizedItemDetail] = useState(false)

    const handleSizedItemDetail = (data) => {
        setSizedItemDetail(!SizedItemDetail)
        setGridData(data)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: ZoneID && ZoneID ? ZoneID : '0',
        Label: ZoneName && ZoneName ? ZoneName : "Select...",
    })

    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
        setWardNameID({
            ...WardNameID,
            ID: 0,
            Label: 'Select...'
        })
    }
    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameID.ID])

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: FromDate,
            ToDate: ToDate,
            M_ZoneID: ZoneNameID.ID ? ZoneNameID.ID : ZoneValue,
            M_WardID: WardNameID.ID,
            T_Encroach_CreateSchedulingID: 0,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: Flag,
            setViewSchedulingData: setViewSchedulingData,
        }
        if (Language.Label != null) {
            dispatch(ViewSchedulingGetTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ToDate, ZoneValue, ZoneNameID.ID, WardNameID.ID])

    const { isLoadingData, tableDataGrid } = useSelector(state => state.ViewSchedulingGetTableData)

    function openFile(fileUrl) {

        if (fileUrl) {
            window.open(fileUrl, '_blank');
        } else {
            console.error('File URL is not provided.');
        }
    }


    return (
        <>
            {isLoadingData && <Loading />}
            {/* <div className="container-scroller"> */}
            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/* Scheduling Grids */}
                            <h5 className="text-dark fw-bold ps-3 pt-2 all_heading_fontsize">
                                {
                                    (ScreenNameTotal == 'Total Scheduling') ?
                                        <> {t('EncroachmentDashboard.TotalScheduling')} </>
                                        : ScreenNameTotal == 'Upcoming Scheduling' ?
                                            <> {t('EncroachmentDashboard.UpcomingScheduling')} </>
                                            : (ScreenNameTotal == 'Pending Scheduling') ?
                                                <> {t('EncroachmentDashboard.PendingScheduling')} </>
                                                :
                                                <> {t('EncroachmentDashboard.CompletedScheduling')} </>

                                }

                                {/* <span className="float-end add_btn">Add</span> */}
                                {/* <span className="add_btn  float-end cursor-pointer" onClick={() => {
                                                handleAddDepartment(true)
                                            }}
                                                title="Add">
                                                <i class="fa-solid fa-plus pe-1"></i> Add
                                            </span> */}
                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 py-2 eic_table_styles" >
                        {
                            ScreenNameTotal == 'Upcoming Scheduling' ?
                                <div class="col-12 col-lg-2 pt-2">
                                    <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                                    <input
                                        className="form-control"
                                        id="FromDate"
                                        type="date"
                                        name="FromDate"
                                        value={FromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        min={FromDate}

                                    />
                                </div>
                                :
                                <div class="col-12 col-lg-2 pt-2">
                                    <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                                    <input
                                        className="form-control"
                                        id="FromDate"
                                        type="date"
                                        name="FromDate"
                                        value={FromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                </div>
                        }

                        <div class="col-12 col-lg-2 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input
                                className="form-control"
                                id="ToDate"
                                type="date"
                                name="ToDate"
                                value={ToDate}
                                onChange={(e) => setToDate(e.target.value)}
                                min={FromDate}
                            />
                        </div>


                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='UserWiseZone'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneValue={ZoneValue}
                                ZoneLabel={ZoneLabel}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <WardNameDDL
                                WardNameID={WardNameID}
                                setWardNameID={setWardNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost=''
                                Language={Language}
                                ZoneNameID={ZoneNameID}
                            />
                        </div>

                        <div className="col-12 col-lg-2 col-md-4 mt-3">

                            {/* <button type="button" className="btn btn-success mx-3">Search</button> */}
                            <button type="button" className="btn btn-danger mt-4" onClick={handleClear}>Clear</button>
                        </div>


                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OrderDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OrderDay')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OrderNumber')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ScheduleDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ScheduleDay')}</th>
                                                {
                                                    ScreenNameTotal == 'Completed Scheduling' &&
                                                    <>
                                                        <th className="text-center">{t('EncroachmentDashboard.CompletedDate')}</th>
                                                        <th className="text-center">{t('EncroachmentDashboard.CompletedDay')}</th>
                                                    </>

                                                }

                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Shift')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ShiftTiming')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.workArea')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Pathak')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ScheduleOrder')}</th>

                                                {
                                                    ((ScreenNameTotal == 'Total Scheduling') || (ScreenNameTotal == 'Pending Scheduling')) &&
                                                    <>
                                                        {/* <th className="text-center">{t('EncroachmentDashboard.Report')}</th> */}
                                                        {/* <th className="text-center">{t('EncroachmentDashboard.VehicleTracking')}</th> */}
                                                    </>

                                                }

                                                {
                                                    ScreenNameTotal == 'Completed Scheduling' &&
                                                    <>
                                                        <th className="text-center">{t('EncroachmentDashboard.BeforePhoto')}</th>
                                                        <th className="text-center">{t('EncroachmentDashboard.AfterPhoto')}</th>
                                                        <th className="text-center">{t('EncroachmentDashboard.SizedItemDetails')}</th>
                                                        <th className="text-center">{t('EncroachmentDashboard.EncroachmentWard')}</th>
                                                        <th className="text-center">{t('EncroachmentDashboard.ActionReport')}</th>
                                                        <th className="text-center">{t('EncroachmentDashboard.Track')}</th>
                                                    </>

                                                }

                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                ViewSchedulingData && ViewSchedulingData.length > 0 ? ViewSchedulingData.map((i, j) => {
                                                    return (
                                                        <tr>
                                                            <td className="py-1" align="center">{i.rowNum}</td>
                                                            <td className="nowrap">{i.orderDate ? moment(i.orderDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td >{i.orderDay ? i.orderDay : '-'}</td>
                                                            <td >{i.orderNumber ? i.orderNumber : '-'}</td>
                                                            <td className="nowrap">{i.scheduleDate ? moment(i.scheduleDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td >{i.scheduleDay ? i.scheduleDay : '-'}</td>
                                                            {
                                                                ScreenNameTotal == 'Completed Scheduling' &&
                                                                <>
                                                                    <td className="nowrap">{i.completedDate ? moment(i.completedDate).format("DD-MM-YYYY") : '-'}</td>
                                                                    <td >{i.completedDay ? i.completedDay : '-'}</td>
                                                                </>

                                                            }
                                                            <td className="nowrap"  >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td className="text-center">
                                                                <button className="button_popUp"
                                                                    onClick={() => handleWardPopup(i)}
                                                                >
                                                                    {/* {t('EncroachmentDashboard.Open')} */}
                                                                    Ward
                                                                </button>
                                                            </td>
                                                            <td >{i.m_Indicator_Shift ? i.m_Indicator_Shift : '-'}</td>
                                                            <td className="nowrap" >{i.workTimeFrom ? i.workTimeFrom : '-'}<hr className="my-0" /> {i.workTimeTo ? i.workTimeTo : '-'}</td>
                                                            <td className="text-center">
                                                                <button className="button_popUp"
                                                                    onClick={() => handleAreaPopup(i)}
                                                                >
                                                                    {/* {t('EncroachmentDashboard.Open')} */}
                                                                    Area
                                                                </button>
                                                            </td>

                                                            <td className="text-center">
                                                                <button className="view_button"
                                                                    onClick={() => {
                                                                        handlePathakDetails(i)
                                                                    }}
                                                                >
                                                                    <td className="nowrap" >{i.pathakName ? i.pathakName : '-'}</td>
                                                                    {/* {t('EncroachmentDashboard.Team')} */}
                                                                    { }
                                                                    {/* <i class="fa-regular fa-image"></i> */}
                                                                </button>
                                                            </td>
                                                            <td className="text-center cursor-pointer">
                                                                <span onClick={() => openFile(i.upload_Doc)}>
                                                                    <i class="fa-solid fa-file pt-2" style={{ fontSize: '20px' }}></i>
                                                                </span>
                                                            </td>
                                                            {/* {
                                                                             ((ScreenNameTotal == 'Total Scheduling') || (ScreenNameTotal == 'Pending Scheduling')) &&
                                                                            <>

                                                                                <td className="text-center">
                                                                                    <span>
                                                                                     
                                                                                        <i class="fa-solid fa-file-pdf pt-2" style={{ fontSize: '20px', color: 'red' }}></i>
                                                                                    </span>
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <span className="Track_button">
                                                                                        
                                                                                        <i class="fa-solid fa-map-location-dot pt-2"></i>
                                                                                    </span>
                                                                                </td>

                                                                            </>
                                                                        } */}
                                                            {
                                                                ScreenNameTotal == 'Completed Scheduling' &&
                                                                <>
                                                                    <td className="text-center pt-2">
                                                                        {
                                                                            (i.schedul_BeforePhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <button className="view_button " onClick={() => handleShowImage(i.schedul_BeforePhoto)}>
                                                                                    {/* {t('EncroachmentDashboard.View')} */}
                                                                                    <i class="fa-regular fa-image"></i>
                                                                                </button>
                                                                        }

                                                                    </td>
                                                                    <td className="text-center pt-2">
                                                                        {
                                                                            (i.schedul_AfterPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <button className="view_button " onClick={() => handleShowImage(i.schedul_AfterPhoto)}>
                                                                                    {/* {t('EncroachmentDashboard.View')} */}
                                                                                    <i class="fa-regular fa-image"></i>
                                                                                </button>
                                                                        }

                                                                    </td>
                                                                    <td className="text-center">
                                                                        <button className="view_button"
                                                                            onClick={() => {
                                                                                handleSizedItemDetail(i)
                                                                            }}
                                                                        >
                                                                            {t('EncroachmentDashboard.View')}
                                                                            {/* <i class="fa-regular fa-image"></i> */}
                                                                        </button>
                                                                    </td>
                                                                    <td >{i.encroachment_Ward ? i.encroachment_Ward : '-'}</td>
                                                                    <td className="text-center">
                                                                        <button className="view_button">
                                                                            {/* {t('EncroachmentDashboard.Open')} */}
                                                                            <i class="fa-solid fa-file-pdf"></i>
                                                                        </button>
                                                                    </td>

                                                                    <td className="text-center">
                                                                        <button className="Track_button">
                                                                            {t('EncroachmentDashboard.Track')}

                                                                        </button>
                                                                    </td>
                                                                </>


                                                            }


                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={20}>No data found ...</td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {ViewSchedulingData && ViewSchedulingData.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={ViewSchedulingData && ViewSchedulingData[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                WardPopup ?
                    <WardGridPopup
                        // message="Add"
                        handleWardPopup={handleWardPopup}
                        heading={t('EncroachmentDashboard.WardName')}
                        Language={Language}
                        GridData={GridData}
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }
            {
                AreaPopup ?
                    <AreaGridPopup
                        // message="Add"
                        handleAreaPopup={handleAreaPopup}
                        heading={t('EncroachmentDashboard.workArea')}
                        Language={Language}
                        GridData={GridData}
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }

            {
                SizedItemDetail ?
                    <SizedItemDetailsPopUp
                        // message="Add"
                        handleSizedItemDetail={handleSizedItemDetail}
                        heading={t('EncroachmentDashboard.SizedItemDetails')}
                        gridData={GridData}
                        DashSelect={DashSelect}
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        ZoneValue={ZoneValue}
                        Language={Language}
                        Flag='OwnerDetails'
                        SizedItemFlag="Scheduling"
                        ScreenNameTotal={ScreenNameTotal}
                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }

            {
                PathakDetails ?
                    <PathakNamePopUp
                        // message="Add"
                        handlePathakDetails={handlePathakDetails}
                        heading={t('EncroachmentDashboard.Pathak')}
                        gridData={GridData}
                        DashSelect={DashSelect}
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        ZoneValue={ZoneValue}
                        Flag='Pathak'
                        Language={Language}

                    // cancelBtnCallBack={handleAddDepartment}
                    /> : <></>
            }
            {
                showImagePopup ?
                    <ViewURL
                        Heading={t('EncroachmentDashboard.View')}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''
            }
        </>
    )
}

